var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleOfPossibilities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 156,
    viewBox: "0 0 152 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_4252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -108,
    width: 264,
    height: 264
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 -108C59.0964 -108 0 -48.9016 0 24.0002C0 96.9016 59.0964 156 132 156C204.901 156 264 96.9016 264 24.0002C264 -48.9016 204.901 -108 132 -108ZM29.4219 24.0002C29.4219 -32.6519 75.3462 -78.5771 132 -78.5771C188.652 -78.5771 234.578 -32.6519 234.578 24.0002C234.578 80.6524 188.652 126.577 132 126.577C75.3462 126.577 29.4219 80.6524 29.4219 24.0002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.001 23.2702H-0.00134277V24.7299H264.001V23.2702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.777 6.04685L1.03271 40.5058L1.22325 41.9531L262.967 7.49406L262.777 6.04685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.314 -10.8689L4.30762 57.4592L4.68542 58.8691L259.692 -9.45893L259.314 -10.8689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.674 -27.1886L9.76733 73.8399L10.3259 75.1885L254.232 -25.84L253.674 -27.1886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.951 -42.6319L17.3185 89.3679L18.0483 90.6321L246.681 -41.3677L245.951 -42.6319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.279 -56.9355L26.8319 103.777L27.7205 104.936L237.168 -55.7774L236.279 -56.9355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.823 -69.8542L38.1448 116.822L39.177 117.854L225.855 -68.822L224.823 -69.8542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.778 -81.1666L51.0636 128.278L52.2217 129.167L212.936 -80.278L211.778 -81.1666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.368 -90.6801L65.3672 137.951L66.6313 138.68L198.632 -89.9502L197.368 -90.6801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.84 -98.2313L80.8109 145.673L82.1595 146.231L183.189 -97.6726L181.84 -98.2313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.459 -103.691L97.1305 151.313L98.5405 151.691L166.869 -103.313L165.459 -103.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.506 -106.966L114.047 154.775L115.494 154.966L149.953 -106.775L148.506 -106.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.27 -108V156H132.73V-108H131.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.047 -106.775L148.506 154.966L149.953 154.775L115.494 -106.966L114.047 -106.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1306 -103.313L165.459 151.691L166.869 151.313L98.5406 -103.691L97.1306 -103.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8108 -97.6726L181.84 146.231L183.189 145.673L82.1594 -98.2313L80.8108 -97.6726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3673 -89.9502L197.368 138.68L198.633 137.951L66.6315 -90.6801L65.3673 -89.9502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0637 -80.278L211.778 129.167L212.936 128.278L52.2218 -81.1666L51.0637 -80.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1448 -68.822L224.823 117.854L225.855 116.822L39.177 -69.8542L38.1448 -68.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8322 -55.7774L236.279 104.936L237.168 103.777L27.7208 -56.9355L26.8322 -55.7774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3186 -41.3677L245.951 90.6321L246.681 89.3679L18.0485 -42.6319L17.3186 -41.3677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76746 -25.84L253.674 75.1885L254.233 73.8399L10.3261 -27.1886L9.76746 -25.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30762 -9.45893L259.314 58.8691L259.692 57.4592L4.68542 -10.8689L4.30762 -9.45893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03259 7.49406L262.777 41.9531L262.967 40.5058L1.22312 6.04685L1.03259 7.49406Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_102_4252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: -79,
    width: 206,
    height: 206
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4219 24.0002C29.4219 80.6524 75.3457 126.577 132 126.577C188.652 126.577 234.578 80.6524 234.578 24.0002C234.578 -32.6519 188.652 -78.5771 132 -78.5771C75.3457 -78.5771 29.4219 -32.6519 29.4219 24.0002ZM66.7596 24.0002C66.7596 -12.0314 95.9682 -41.2402 132 -41.2402C168.031 -41.2402 197.24 -12.0314 197.24 24.0002C197.24 60.0309 168.031 89.2402 132 89.2402C95.9682 89.2402 66.7596 60.0309 66.7596 24.0002Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_102_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.658 14.4595L0.244507 32.0841L0.341958 33.5405L263.755 15.9159L263.658 14.4595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.286 -2.64344L2.42688 49.2122L2.7136 50.6435L261.573 -1.21217L261.286 -2.64344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.703 -19.2906L6.82617 65.9091L7.29726 67.2907L257.174 -17.909L256.703 -19.2906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.985 -35.1968L13.3674 81.8889L14.0148 83.1972L250.633 -33.8885L249.985 -35.1968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.249 -50.0907L21.9385 96.8781L22.7511 98.0907L242.062 -48.8781L241.249 -50.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.643 -63.7165L32.3926 110.62L33.3565 111.717L231.607 -62.6204L230.643 -63.7165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.35 -75.8414L44.5511 122.881L45.6499 123.842L219.449 -74.8804L218.35 -75.8414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.579 -86.2582L58.2058 133.449L59.4206 134.258L205.794 -85.4489L204.579 -86.2582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.567 -94.7884L73.1233 142.145L74.4334 142.788L190.877 -94.1445L189.567 -94.7884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.569 -101.286L89.0481 148.819L90.431 149.286L174.952 -100.818L173.569 -101.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.86 -105.64L105.708 153.357L107.14 153.64L158.292 -105.357L156.86 -105.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.726 -107.776L122.817 155.682L124.274 155.776L141.183 -107.682L139.726 -107.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.459 -107.657L140.084 155.754L141.54 155.657L123.916 -107.754L122.459 -107.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.356 -105.285L157.212 153.572L158.644 153.285L106.788 -105.572L105.356 -105.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.709 -100.701L173.91 149.173L175.291 148.702L90.0906 -101.172L88.709 -100.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8025 -93.9839L189.889 142.632L191.198 141.984L74.1108 -94.6313L72.8025 -93.9839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9086 -85.2478L204.879 134.061L206.091 133.248L59.1212 -86.0605L57.9086 -85.2478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2826 -74.6423L218.621 123.606L219.717 122.643L45.3788 -75.6063L44.2826 -74.6423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1576 -62.3494L230.882 111.448L231.842 110.349L33.1186 -63.4482L32.1576 -62.3494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7406 -48.5784L241.45 97.7935L242.259 96.5787L22.5499 -49.7932L21.7406 -48.5784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2103 -33.5658L250.146 82.8763L250.789 81.5662L13.8542 -34.8759L13.2103 -33.5658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71301 -17.5687L256.82 66.9515L257.287 65.5687L7.18035 -18.9515L6.71301 -17.5687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35864 -0.859989L261.358 50.292L261.641 48.8599L2.64147 -2.29204L2.35864 -0.859989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.2229 16.2743L263.684 33.1826L263.777 31.7259L0.316391 14.8175L0.2229 16.2743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_102_4252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: -42,
    width: 132,
    height: 132
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7595 24.0003C66.7595 60.031 95.9682 89.2402 132 89.2402C168.031 89.2402 197.24 60.031 197.24 24.0003C197.24 -12.0313 168.031 -41.2401 132 -41.2401C95.9682 -41.2401 66.7595 -12.0313 66.7595 24.0003ZM89.4343 24.0003C89.4343 0.49144 108.491 -18.5656 132 -18.5656C155.508 -18.5656 174.566 0.49144 174.566 24.0003C174.566 47.5087 155.508 66.5657 132 66.5657C108.491 66.5657 89.4343 47.5087 89.4343 24.0003Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_102_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.001 23.2703H-0.00134277V24.73H264.001V23.2703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.777 6.04703L1.03271 40.506L1.22325 41.9532L262.967 7.49424L262.777 6.04703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.314 -10.8688L4.30762 57.4592L4.68542 58.8692L259.692 -9.45887L259.314 -10.8688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.674 -27.1885L9.76733 73.84L10.3259 75.1886L254.232 -25.8399L253.674 -27.1885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.951 -42.6317L17.3185 89.3681L18.0483 90.6322L246.681 -41.3676L245.951 -42.6317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.279 -56.9354L26.832 103.778L27.7207 104.936L237.168 -55.7773L236.279 -56.9354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.823 -69.8541L38.1449 116.822L39.1771 117.854L225.855 -68.822L224.823 -69.8541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.778 -81.1666L51.0636 128.278L52.2217 129.167L212.936 -80.278L211.778 -81.1666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.368 -90.68L65.3672 137.951L66.6313 138.68L198.632 -89.9501L197.368 -90.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.84 -98.2312L80.8109 145.673L82.1595 146.232L183.189 -97.6726L181.84 -98.2312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.459 -103.691L97.1306 151.313L98.5406 151.691L166.869 -103.313L165.459 -103.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.506 -106.966L114.047 154.776L115.494 154.966L149.953 -106.775L148.506 -106.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.27 -108V156H132.73V-108H131.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.047 -106.775L148.506 154.966L149.953 154.776L115.494 -106.966L114.047 -106.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1306 -103.313L165.459 151.691L166.869 151.313L98.5406 -103.691L97.1306 -103.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8108 -97.6726L181.84 146.232L183.189 145.673L82.1594 -98.2312L80.8108 -97.6726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3674 -89.9501L197.369 138.68L198.633 137.951L66.6316 -90.6799L65.3674 -89.9501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0636 -80.278L211.778 129.167L212.936 128.278L52.2217 -81.1666L51.0636 -80.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1448 -68.822L224.823 117.854L225.855 116.822L39.177 -69.8541L38.1448 -68.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8322 -55.7773L236.279 104.936L237.168 103.778L27.7208 -56.9354L26.8322 -55.7773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3186 -41.3676L245.951 90.6322L246.681 89.3681L18.0485 -42.6317L17.3186 -41.3676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76746 -25.8399L253.674 75.1886L254.233 73.84L10.3261 -27.1885L9.76746 -25.8399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30762 -9.45887L259.314 58.8692L259.692 57.4592L4.68542 -10.8688L4.30762 -9.45887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03259 7.49424L262.777 41.9532L262.967 40.506L1.22312 6.04703L1.03259 7.49424Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOfPossibilities);
export default __webpack_public_path__ + "static/media/circle-of-possibilities.2dc8f508db21b0ac4ae20918a83c9dce.svg";
export { ForwardRef as ReactComponent };